<div class="main-body">
  <div class="banner-box">
    <div class="banner-content">
      <span class="welcome-text">Welcome back, {{ username }}</span>
      <h1>FSO Credit risk analysis</h1>
      <h3>Track and manage all of your engagements in one place.</h3>
    </div>
  </div>
  <!-- global loader: blocks UI during SharePoint fetch -->
  <motif-progress-loader
    [show]="showLoader"
    [fullScreen]="true"
  ></motif-progress-loader>

  <div class="motif-col-xs-8 motif-col-sm-8 motif-col-md-8 motif-col-lg-8">
    <motif-toast
      *ngIf="showToast"
      [autoHide]="false"
      type="info"
      [show]="showToast"
      ariaLabelCloseButton="Close info toast message"
    >
      <ng-container *ngIf="toastType == 'success'">
        {{ toastMessage }}
      </ng-container>
      <ng-container *ngIf="toastType == 'error'">
        {{ toastMessage }}
      </ng-container>
      <ng-container *ngIf="toastType == 'info'">
        {{ toastMessage }}
      </ng-container>
      <ng-container *ngIf="toastType == 'warning'">
        warning message
      </ng-container>
    </motif-toast>
  </div>

  <mat-tab-group>
    <mat-tab label="Credit Risk Review (CRR)">
      <div class="tab-header">All engagements</div>

      <mat-accordion>
        <mat-expansion-panel
          (opened)="panelOpenState.set(true)"
          (closed)="panelOpenState.set(false)"
          [expanded]="expandPanel"
        >
          <div
            *ngIf="expandPanel"
            style="
              width: 100vw;
              margin-left: -50vw;
              left: 50%;
              position: relative;
              border-bottom: 1.5px solid #e0e0e0;
              margin-bottom: 18px;
            "
          ></div>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon
                style="vertical-align: middle; margin-right: 8px; color: black"
              >
                {{
                  panelOpenState() ? "keyboard_arrow_up" : "keyboard_arrow_down"
                }}
              </mat-icon>
              <span style="text-wrap: nowrap !important; margin-right: auto; font-family: EYInterstate; display: inline-flex; align-items: center; gap: 10px;">
                <span class="client-avatar" [ngStyle]="clientAvatarStyle" aria-hidden="true">{{ clientInitials }}</span>
                <span class="client-name">{{ client_name }}</span>
              </span>

              <!-- Fetch Data triggers SharePoint ingestion; show full-screen loader -->

              <button
                motif-button
                size="large"
                style="text-wrap: nowrap"
                class="refresh-button"
                (click)="onFetchData()"
                [disabled]="isAnyInProgress || showLoader"
                [ngClass]="{ disabled: isAnyInProgress || showLoader }"
              >
                <motif-icon [iconFunction]="refreshIcon" class="refresh-icon">
                </motif-icon>
                Fetch Data
              </button>

              <button
                motifButton
                color="primary"
                size="small"
                variant="null"
                class="view-all-btn text-nowrap"
              >
                View all engagements
              </button>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Empty state when there are no engagements -->
          <div *ngIf="(refreshData?.length || 0) === 0" class="empty-state" style="margin: 16px 0;">
            <mat-card appearance="outlined" style="text-align: center; padding: 24px;">
              <mat-card-content style="font-size: 16px; font-weight: 500; color: #555; font-family: EYInterstate;">
                No engagements found. Use the <strong>Fetch Data</strong> button above to ingest engagement periods.
              </mat-card-content>
            </mat-card>
          </div>

          <div *ngFor="let data of pagedData; let i = index">
            <mat-card
              appearance="outlined"
              [ngClass]="{
                'current-engagement': i === selectedEngagementIndex
              }"
              (click)="setCurrentEngagement(i)"
              style="cursor: pointer"
            >
              <mat-card-content>
                <div class="engagement-row">
                  <div
                    class="vertical-bar"
                    *ngIf="i === selectedEngagementIndex"
                  ></div>
                  <div class="engagement-main">
                    <div
                      class="engagement-info-row"
                      style="display: flex; align-items: flex-start; gap: 32px"
                    >
                      <div class="engagement-title-row">
                        <span
                          class="engagement-title"
                          [ngStyle]="
                            i !== selectedEngagementIndex
                              ? { 'margin-top': '12px' }
                              : {}
                          "
                        >
                          {{ data.year }} {{ data.quarter }} Credit risk review
                        </span>
                        <span
                          *ngIf="i === selectedEngagementIndex"
                          class="current-label"
                          >Current</span
                        >
                      </div>
                      <div
                        class="engagement-info-block"
                        [ngStyle]="{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          marginLeft:
                            i === selectedEngagementIndex ? '17.3%' : '20%'
                        }"
                      >
                        <span class="info-label">Last fetched on</span>
                        <span class="info-value">{{
                          data.completed_at
                            ? (data.completed_at | date : "dd MMM yyyy")
                            : "--"
                        }}</span>
                      </div>
                      <div
                        style="
                          width: 2px;
                          height: 40px;
                          background: #bdbdbd96;
                          margin: 0 12px;
                          align-self: stretch;
                          border-radius: 1px;
                        "
                      ></div>
                      <div
                        class="engagement-info-block"
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: flex-start;
                        "
                      >
                        <span class="info-label">Integration status</span>
                        <span
                          class="info-value"
                          style="
                            display: inline-flex;
                            align-items: center;
                            font-size: 14px;
                            gap: 8px;
                            margin-bottom: 0px !important;
                            position: relative;
                          "
                        >
                          {{
                            data.overall_status
                              ? getDisplayStatus(data.overall_status)
                              : "--"
                          }}
                          <span *ngIf="data.overall_status" class="tooltip-anchor">
                            <mat-icon
                              (mouseenter)="showStatusTooltip(i)"
                              (mouseleave)="hideStatusTooltip()"
                              class="ml-4 mt-2 header-info"
                              style="vertical-align: middle; font-size: 18px"
                              >info</mat-icon>
                            <!-- custom tooltip with percent-based circular progress -->
                            <div
                              class="integration-tooltip"
                              *ngIf="tooltipRowIndex === i"
                            >
                            <div class="tooltip-title" style="font-weight: 600; font-size: 12px; margin-bottom: 8px; color: #333;">
                              Integration status
                            </div>
                            <div class="tooltip-row">
                              <span>Ingestion</span>
                              <span class="tooltip-right">
                                <mat-icon *ngIf="getStepClass(data.percent_completion?.INGESTION) === 'done'" class="check-icon">check_circle_outline</mat-icon>
                                <span *ngIf="getStepClass(data.percent_completion?.INGESTION) === 'progress'" class="spinner-circle"></span>
                                <span *ngIf="getStepClass(data.percent_completion?.INGESTION) === 'idle'" class="idle-dot"></span>
                                <span *ngIf="getStepClass(data.percent_completion?.INGESTION) !== 'done'" class="percent-label">{{ (data.percent_completion?.INGESTION || 0) }}%</span>
                              </span>
                            </div>
                            <div class="tooltip-row">
                              <span>Classification</span>
                              <span class="tooltip-right">
                                <mat-icon *ngIf="getStepClass(data.percent_completion?.CLASSIFICATION) === 'done'" class="check-icon">check_circle_outline</mat-icon>
                                <span *ngIf="getStepClass(data.percent_completion?.CLASSIFICATION) === 'progress'" class="spinner-circle"></span>
                                <span *ngIf="getStepClass(data.percent_completion?.CLASSIFICATION) === 'idle'" class="idle-dot"></span>
                                <span *ngIf="getStepClass(data.percent_completion?.CLASSIFICATION) !== 'done'" class="percent-label">{{ (data.percent_completion?.CLASSIFICATION || 0) }}%</span>
                              </span>
                            </div>
                            <!-- not using this vectorization for databricks implementation, can add back if needed in the future
                            <div class="tooltip-row">
                              <span>Vectorization</span>
                              <span class="tooltip-right">
                                <mat-icon *ngIf="getStepClass(data.percent_completion?.VECTORIZATION) === 'done'" class="check-icon">check_circle_outline</mat-icon>
                                <span *ngIf="getStepClass(data.percent_completion?.VECTORIZATION) === 'progress'" class="spinner-circle"></span>
                                <span *ngIf="getStepClass(data.percent_completion?.VECTORIZATION) === 'idle'" class="idle-dot"></span>
                                <span *ngIf="getStepClass(data.percent_completion?.VECTORIZATION) !== 'done'" class="percent-label">{{ (data.percent_completion?.VECTORIZATION || 0) }}%</span>
                              </span>
                            </div> -->
                            </div>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="engagement-actions">
                    <button
                      mat-button
                      class="ingest"
                      (click)="startOrchestration(data.year, data.quarter)"
                      [ngClass]="{
                        disabled:
                          isProcessDisabled(data.overall_status) ||
                          processingKey === data.year + '_' + data.quarter
                      }"
                      [disabled]="
                        isProcessDisabled(data.overall_status) ||
                        processingKey === data.year + '_' + data.quarter
                      "
                    >
                      Process Documents
                      <img
                        style="vertical-align: middle"
                        src="database-backup.png"
                      />
                    </button>
                    <button
                      mat-button
                      color="accent"
                      class="view-button"
                      (click)="goToViewScreen(data.year, data.quarter)"
                    >
                      View Obligors
                      <img
                        style="vertical-align: middle; color: white"
                        src="eye.png"
                      />
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
            <div *ngIf="(refreshData?.length || 0) > 0" style="display: flex; justify-content: space-between; align-items: center; margin-top: 16px;">
              <div style="font-weight: 500; font-size: 16px; font-family: EYInterstate;">
                Total items: {{ refreshData.length || 0 }}
              </div>
              <motif-pagination role="navigation">
                <motif-pagination-select
                  label="Show"
                  style="text-wrap: nowrap;"
                  [options]="pageSizeOptions"
                  [selected]="selectedPageSize"
                  (change)="onPageSizeChange($event)"
                >
                </motif-pagination-select>
                <button motifIconButton aria-label="Go to first page" (click)="goToPage(1)" [disabled]="currentPage === 1">
                  <mat-icon>first_page</mat-icon>
                </button>
                <button motifIconButton aria-label="Go to previous page" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <motif-count role="status" [currentPage]="currentPage" [numberOfPages]="numberOfPages"></motif-count>
                <button motifIconButton aria-label="Go to next page" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === numberOfPages">
                  <mat-icon>chevron_right</mat-icon>
                </button>
                <button motifIconButton aria-label="Go to last page" (click)="goToPage(numberOfPages)" [disabled]="currentPage === numberOfPages">
                  <mat-icon>last_page</mat-icon>
                </button>
              </motif-pagination>
            </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-tab>
  </mat-tab-group>
  <footer>
    <div class="footer">
      EY does not intentionally collect any sensitive personal data from you via
      the Tool. The Tool’s intention is not to process such information.
      Accordingly, you should not enter any unnecessary personal information or
      any sensitive personal data (including government identifiers such as tax
      file numbers or social security numbers/national identification numbers),
      client confidential information (except client entity names), audit
      secrets, state secrets, trade secrets, or anything that would violate
      professional secrecy or confidentiality rules or that would be considered
      abusive/irrelevant in the Tool.
    </div>
  </footer>
  <div class="cookie-alert" *ngIf="showCookieAlert">
    <div class="cookie-content">
      <div class="cookie-header">
        <h3>Cookie Notice</h3>
        <button class="close-button" (click)="dismissCookieAlert()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <p>
        This website uses cookies to enhance your browsing experience and
        provide personalized content. By continuing to use this site, you
        consent to our use of cookies.
      </p>
      <div class="cookie-actions">
        <button motif-button variant="primary" (click)="acceptCookies()">
          Accept
        </button>
      </div>
    </div>
  </div>
</div>
